import { create } from 'zustand';

/**
 * Visibility of the quick feedback dialog, held app-wide so ANY page's ⋮ menu
 * can raise it: a dialog owned by the menu would unmount with it on the very
 * click that opens it. The dialog itself is mounted once, in the app shell.
 */
interface QuickFeedbackState {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

export const useQuickFeedbackStore = create<QuickFeedbackState>((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
}));
